import { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Component = styled.div`
  overflow: ${props => (props.show ? 'visible' : 'hidden')};
  opacity: ${props => (props.show ? '1' : '0')};
  max-height: ${props => (props.show ? '100%' : '0px')};
  transition: all 0.8s ease-in-out 0.3s;
`

const Transition = ({ children, show }) => {
  const [showContent, setShowContent] = useState(false)

  useEffect(() => {
    setShowContent(show)
  }, [show])

  return <Component show={showContent}>{children}</Component>
}

Transition.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
}

export default Transition
